import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { AppConfigService } from 'libs/core/src/lib/app-config.service';

@Component({
    selector: 'justonweb-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss'],
    standalone: false
})
export class DocumentComponent {

  constructor(
    private activatedRoute: ActivatedRoute,
    private translocoService: TranslocoService,
    private appConfigService: AppConfigService,
    private router: Router
  ) {
    const config = this.appConfigService.getConfig();
    const lang = this.activatedRoute.snapshot.queryParams['lang'] ?? this.translocoService.getActiveLang();
    const documentId = this.activatedRoute.snapshot.params['documentId'];
    const loginType = localStorage.getItem('loginType');

    console.log('lang: ', lang);
    console.log('documentId: ', documentId);
    console.log('loginType: ', loginType);

    if (!loginType) this.router.navigateByUrl('/');

    let redirectUrl = '';
    if (loginType == 'lawyerCard' || loginType == 'staff') {
      redirectUrl = config['appBaseUrlLawyer' + lang.toUpperCase()];
    } else {
      redirectUrl = config['appBaseUrl'];
    }
    console.log('redirecting to: ', redirectUrl + '/document/' + documentId + '?lang=' + lang);
    window.location.href = redirectUrl + '/document/' + documentId + '?lang=' + lang;
  }

}
